<template>
    <div class="order-manage">
        <div>
            <h2>我的订单</h2>
            <div class="order-table">
                <el-table :data="mergedData" :span-method="spanMethod" border :cell-style="{ borderColor: '#EBEEF5' }"
                    :header-cell-style="{ borderColor: '#EBEEF5', backgroundColor: '#F5F7FA' }">
                    <el-table-column label="商品信息" align="center">
                        <template slot-scope="scope">
                            <!-- 订单信息 -->
                            <div v-if="scope.row.type === 'order'" class="order-header">
                                <div class="order-info">
                                    <div class="order-number">订单号：{{ scope.row.orderSn }}</div>
                                    <div class="order-date">{{ scope.row.createTime }}</div>
                                </div>
                                <div class="order-total">
                                    合计：<span class="order-amount">¥{{ scope.row.orderPrice }}</span>
                                    <span class="order-mail">(含邮费{{ scope.row.shipPrice ? scope.row.shipPrice : 0
                                    }}元)</span>
                                </div>
                                <div class="order-status">
                                    <span class="status-label" :class="getStatusClass(scope.row.orderStatus)">
                                        {{ scope.row.orderStatusName }}
                                    </span>
                                </div>
                                <span class="order-detail-link" @click="checkOrder(scope.row)">订单详情</span>
                                <div class="order-actions">
                                    <el-button v-if="scope.row.orderStatus == 1 || scope.row.orderStatus == 2"
                                        type="primary" size="mini" @click="cancelOrder(scope.row)">取消订单</el-button>
                                    <el-button v-if="scope.row.orderStatus == 1" type="primary" size="mini"
                                        @click="payOrder(scope.row)">去支付</el-button>

                                    <el-button v-if="scope.row.orderStatus == 3" type="primary" size="mini"
                                        @click="cancelOrder(scope.row)">取消订单</el-button>
                                    <el-button v-if="scope.row.orderStatus == 3 || scope.row.orderStatus == 3"
                                        type="primary" size="mini" @click="checkLogistics(scope.row)">查看物流</el-button>
                                </div>
                            </div>
                            <!-- 商品信息 -->
                            <div v-else class="product-info" @click="toShopDetail(scope.row.goodsId)">
                                <img :src="scope.row.newImg" class="product-image" />
                                <div class="product-detail">
                                    <el-tooltip class="item" effect="dark" :content="scope.row.goodsName"
                                        placement="top">
                                        <div class="product-name-ellipsis">{{ scope.row.goodsName }}</div>
                                    </el-tooltip>
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="price" label="规格" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.type !== 'order'">￥{{ scope.row.specification }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="数量" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.type !== 'order'">{{ scope.row.specificationValue }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="quantity" label="合计" align="center">
                        <template slot-scope="scope">
                            <div>合计：{{ scope.row.totalPrice }}</div>
                            <div>(含邮费{{ scope.row.num * scope.row.mailPrice }}元)</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderStatusName" label="操作" align="center">
                        <template slot-scope="scope">
                            <!-- 订单行：显示订单级操作 -->
                            <template v-if="scope.row.type === 'order'">
                                <!-- 订单级别的按钮（如有） -->
                            </template>
                            <!-- 商品行：显示去评价按钮（前提是父订单状态为已收货） -->
                            <template v-else>
                                <el-button v-if="getOrderStatusByProduct(scope.row) === '已收货'" type="primary"
                                    size="mini" @click="goComment(scope.row)">去评价</el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination background layout="total, prev, pager, next, jumper" :current-page="query.pageNum"
                    :page-size="query.pageSize" :total="total" @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="物流信息" :visible.sync="logisticsDialogVisible" width="500px">
            <el-timeline>
                <el-timeline-item v-for="(log, index) in logisticsInfo" :key="index" :timestamp="log.timeDesc"
                    :color="index === 0 ? '#13ce66' : ''" placement="top">
                    <div class="logistics-desc">
                        <div class="logistics-status">
                            <span class="logistics-city">{{ log.areaName }}</span>
                            <span class="logistics-status-text">{{ getStatusText(log.logisticsStatus) }}</span>
                        </div>
                        <div class="logistics-detail">{{ log.desc }}</div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </el-dialog>
    </div>
</template>

<script>
import { myOrder, cancelOrder, confirmReceipt, getLogisticsInfo } from '@/api/sjzx'
export default {
    name: 'orderManage',
    data() {
        return {
            baseUrl: window.globalUrl.HOME_API,
            query: {
                pageNum: 1,
                pageSize: 10,
            },
            form: {
                courierNumber: '',////快递单号
                logisticsCompanyId: '',////物流公司id
                orderItemId: '',//子订单号
            },
            tableData: [

            ],
            total: 0,
            logisticsDialogVisible: false,
            logisticsInfo: [], // 物流信息数组
        }
    },
    computed: {
        // ...mapGetters(["identityObj"]),
        // 重组数据：插入订单信息行
        mergedData() {
            // console.log(this.tableData, '查看this.tableData')
            return this.tableData.flatMap(order => [
                { type: "order", ...order }, // 插入订单行
                ...order.orderProductList.map(p => ({ type: "product", ...p })), // 插入商品行
            ]);
        },
    },
    mounted() {
        this.getMyOrderList()

    },
    methods: {
        toShopDetail(id) {
            console.log(id, '查看id是什么') +
                //跳转商品详情页
                this.$router.push({ name: 'shopDetail', query: { id } });
        },
        getStatusText(status) {
            const map = {
                'ACCEPT': '已揽收',
                'TRANSPORT': '运输中',
                'DELIVERED': '已签收',
                'AGENT_SIGN': '代收签收',
                'DELIVERING': '派送中',
                'SIGN': '已签收'
                // 可根据实际数据补充
            }
            return map[status] || status
        },
        handleExport() {
            // 导出明细处理逻辑
            console.log('导出明细')
        },

        handlePageChange(page) {
            this.query.pageNum = page;
            this.getMyOrderList();
        },
        changeList(arr) {
            //改变订单图片结构
            arr.forEach(item => {
                item.orderProductList.forEach(its => {
                    try {
                        its.newImg = this.baseUrl + 'admin/file/get?ossFilePath=' + JSON.parse(its.goodsImg)[0].url;
                    } catch (error) {
                        console.error('解析JSON字符串时出错:', error);
                    }
                });
            });
            return arr
        },
        async getMyOrderList() {
            //订单列表
            let params = {
                ...this.query
            }
            let res = await myOrder(params)
            this.tableData = this.changeList(res.data.records)
            this.total = Number(res.data.total) // 赋值总条数
        },

        spanMethod({ row, column, rowIndex, columnIndex }) {
            // 合并单元格逻辑
            if (row.type === "order") {
                // 订单行：合并所有列（独占一行）
                if (columnIndex === 0) {
                    return { rowspan: 1, colspan: 5 }; // 合并3列
                } else {
                    return { rowspan: 0, colspan: 0 }; // 其他列不显示
                }
            }
        },

        checkOrder(obj) {
            //我的订单详情
            // console.log(obj, '查看obj')
            this.$router.push({
                name: 'wdddxq', query: {
                    orderItemId: obj.orderItemId
                }
            })

        },
        async cancelOrder(row) {
            /* 取消订单逻辑 */
            console.log(row)
            let params = {
                orderItemId: row.orderItemId
            }
            let res = await cancelOrder(params)
            if (res.code == 0) {
                this.getMyOrderList()
                this.$message({
                    type: 'success', // success error warning
                    message: res.msg,
                    duration: 2000,
                })
            } else {
                this.$message({
                    type: 'error', // success error warning
                    message: res.msg,
                    duration: 2000,
                })
            }
        },
        payOrder(row) {
            /* 去支付逻辑 */
            console.log(row, '查看row')
            this.$router.push({
                name: 'OrderSubmitSuccess', query: {
                    orderId: row.orderItemId,
                    totalPrice: row.orderPrice,
                    orderType: '1'
                }
            })
        },
        async checkLogistics(row) {
            // 这里可以调用接口获取物流信息
            // let res = await getLogisticsInfo(row.orderItemId)
            // this.logisticsInfo = res.data
            // 测试用静态数据
            // this.logisticsInfo = [
            //     {
            //         status: '已发货',
            //         time: '2023-06-16 09:15:00',
            //         desc: '您的订单已由顺丰快递揽收，运单号: SF1234567890'
            //     },
            //     {
            //         status: '运输中',
            //         time: '2023-06-16 14:30:00',
            //         desc: '快件已到达【上海转运中心】'
            //     }
            // ]
            console.log(row, '查看row')

            let res = await getLogisticsInfo({ orderItemId: row.orderItemId })
            this.logisticsInfo = res.data.logisticsTraceDetailList

            this.logisticsDialogVisible = true
        },

        confirmReceive(row) {
            /* 确认收货 */
            this.$confirm('确认收到货了吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    orderItemId: row.orderItemId
                }
                let res = await confirmReceipt(params)
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    this.getMyOrderList()
                } else {
                    this.$message.error(res.msg)
                }

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });


        },
        goComment(row) {
            /* 去评价 */
            console.log(row, '查看row')
            this.$router.push({
                name: 'goComment', query: {
                    shopDetail: row
                }
            })
        },
        getStatusClass(status) {
            let type = Number(status)
            switch (type) {
                case 3:
                    return 'status-wait-receive';
                case 4:
                    return 'status-wait-comment';
                case 2:
                    return 'status-wait-send';
                case 1:
                    return 'status-wait-pay';
                case 0:
                    return 'status-finished';
                default:
                    return '';
            }
        },
        getOrderStatusByProduct(productRow) {
            // 在 mergedData 里找到最近的 type === 'order' 的行（即父订单行）
            const index = this.mergedData.findIndex(item => item === productRow);
            for (let i = index - 1; i >= 0; i--) {
                if (this.mergedData[i].type === 'order') {
                    return this.mergedData[i].orderStatusName;
                }
            }
            return null;
        }
    }
}

</script>

<style lang="less" scoped>
.order-manage {
    padding: 20px;
    background-color: #fff;

    h2 {
        font-size: 18px;
        margin-bottom: 20px;
        font-weight: bold;
    }



    .order-table {
        .order {
            width: 100%;
            height: auto;
            display: flex;
            justify-content: space-around;
            align-items: center;
            text-align: center;
            /* background-color: #ccc; */
        }

        margin-bottom: 20px;

        .order-number {
            font-weight: bold;
            margin-bottom: 5px;
        }

        .order-date {
            font-size: 12px;
            color: #999;
        }

        .buyer-info,
        .product-info {

            display: flex;
            justify-content: center;
            align-items: center;

            .buyer-avatar,
            .product-image {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 10px;
            }

            .product-image {
                border-radius: 4px;
            }

            .buyer-detail,
            .product-detail {
                font-size: 14px;

                .product-spec {
                    font-size: 12px;
                    color: #999;
                    margin-top: 5px;
                }

                .product-count {
                    font-size: 12px;
                    color: #409EFF;
                    margin-top: 5px;
                }
            }
        }

        .price {
            font-weight: bold;
        }

        .price-tag {
            font-size: 12px;
            color: #999;
            margin-top: 5px;
        }

        .discount {
            font-size: 12px;
            color: #ff6700;
            margin-top: 5px;
        }

        .children-products {
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px dashed #EBEEF5;
        }

        .child-product-info {
            display: flex;
            align-items: center;
            margin-top: 8px;

            .child-product-image {
                width: 30px;
                height: 30px;
                border-radius: 4px;
                margin-right: 8px;
            }

            .child-product-detail {
                font-size: 12px;

                .child-product-spec {
                    font-size: 12px;
                    color: #999;
                    margin-top: 3px;
                }
            }
        }
    }

    .pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .total-info {
            color: #999;
            font-size: 14px;
        }
    }

    .order-detail {
        padding: 0 20px;

        .detail-item {
            margin-bottom: 12px;
            line-height: 20px;
            display: flex;

            .label {
                color: #606266;
                min-width: 80px;
                text-align: right;
                margin-right: 10px;
            }

            .value {
                flex: 1;
                color: #333;
            }

            .copy-btn {
                margin-left: 10px;
                color: #333;
                background-color: #fff;
                border-color: #dcdfe6;
                padding: 4px 10px;
                font-size: 12px;
            }
        }

        .product-list {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin-top: 5px;
        }

        .product-container {
            display: flex;
            align-items: center;
            margin-top: 5px;

            .product-img {
                width: 50px;
                height: 50px;
                object-fit: cover;
                border-radius: 4px;
                margin-right: 10px;
            }

            .product-name {
                flex: 1;
                font-size: 14px;
            }

            .product-tag {
                font-size: 12px;
                color: #fff;
                background-color: #67c23a;
                padding: 2px 6px;
                border-radius: 2px;
                margin-left: 10px;
            }
        }
    }

    .shipping-info {
        margin-top: 20px;
        border-top: 1px dashed #ebeef5;
        padding-top: 15px;

        .shipping-select {
            width: 100%;
        }

        .tracking-input {
            width: 100%;
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;

        .footer-left {
            text-align: left;

            .chat-btn {
                color: #333;
                background-color: #fff;
                border-color: #dcdfe6;
            }
        }

        .footer-right {
            text-align: right;
        }
    }
}

.white-bg {
    width: 100%;
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: 800;
}

.order-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 8px;

    .order-info {
        flex: 2;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .order-number {
            font-size: 14px;
            color: #333;
            margin-bottom: 2px;
        }

        .order-date {
            font-size: 12px;
            color: #999;
            margin-left: 0;
        }
    }

    .order-total {
        flex: 1;
        font-size: 14px;
        color: #333;

        .order-amount {
            font-weight: bold;
            color: #222;
        }

        .order-mail {
            font-size: 12px;
            color: #999;
            margin-left: 4px;
        }
    }

    .order-status {
        flex: 0.8;

        .status-label {
            background: #ffeaea;
            color: #ff5b5b;
            border-radius: 12px;
            padding: 2px 12px;
            font-size: 13px;
            display: inline-block;

            &.status-wait-receive {
                background: #DBFEE6;
                color: #F56157;
            }

            &.status-wait-comment {
                background: #DCFCE7;
                color: #16A34A;
            }

            &.status-wait-send {
                background: #DBFEE6;
                color: #2563EB;
            }

            &.status-wait-pay {
                background: #F7DEDE;
                color: #F56157;
            }

            &.status-finished {
                background: #f0f0f0;
                color: #999;
            }
        }
    }

    .order-actions {
        flex: 1.2;
        display: flex;
        gap: 8px;
        min-width: 320px;
        max-width: 400px;
        justify-content: flex-end;
    }

    .order-detail-link {
        color: #222;
        text-decoration: underline;
        font-weight: 500;
        padding: 0 8px;
        background: none;
        border: none;
        cursor: pointer;
        font-size: 14px;
        transition: color 0.2s;
        display: inline-block;
    }

    .order-detail-link:hover {
        color: #000;
    }
}

.product-name-ellipsis {
    max-width: 160px;
    /* 根据实际情况调整 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
}

.product-detail {
    width: 160px;
    /* 固定宽度，可根据实际需求调整 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
}
</style>
